import { formatText } from "@ui/format";
import type { CommonOptions } from "bm-ui-kit";
import type { LoanGoal } from "../LeadForm/types";
import type { PersonalLoanSearchParams, PersonalLoanSort } from "./types";

function generateList(min: number, max: number, step: number): number[] {
	const options = [];
	for (let i = min; i <= max; i += step) {
		options.push(i);
	}

	return options;
}

export const CREDIT_EXCHANGE: CommonOptions = [{ label: "Adósságrendező hitel", value: "CREDIT_EXCHANGE" }];

export const LOAN_GOALS: CommonOptions<LoanGoal> = [
	{ label: "Szabad felhasználás", value: "SZABAD_FELHASZNALAS" },
	{ label: "Lakásfelújítás", value: "LAKASFELUJITAS" },
	{ label: "Gépjármű vásárlás", value: "GEPJARMU_VASARLAS" },
	{ label: "Saját banki hitelkiváltás", value: "SAJAT_BANKI_HITELKIVALTAS" },
	{ label: "Idegen banki hitelkiváltás", value: "IDEGEN_BANKI_HITELKIVALTAS" },
	{ label: "Energetikai korszerűsítés", value: "ENERGETIKAI_KORSZERUSITES" },
	{ label: "Lakásvásárlás", value: "LAKASVASARLAS" },
];

export const MIN_LOAN_AMOUNT = 800_000;
export const MAX_LOAN_AMOUNT = 15_000_000;

export const MIN_MATURITY = 1;
export const MAX_MATURITY = 8;

export const MAX_EMPLOYMENT_MONTHS = 12 * 60;

export const MAX_TOTAL_INCOME = 10_000_000;

export const DEFAULT_PARAMS: PersonalLoanSearchParams = {
	loanAmount: 3_000_000,
	maturityYears: 7,
	employmentMonths: 12,
	income: 250_000,
	loanGoal: "SZABAD_FELHASZNALAS",
	fasterAdministration: true,
	receiptOfIncome: true,
	activeBankContact: true,
	onePerBank: true,
	sort: "APR",
};

export const DEFAULT_PARAMS_SBERBANK = {
	...DEFAULT_PARAMS,
	loanAmount: 5_000_000,
	maturityYears: 8,
};

export const SORT_OPTIONS: CommonOptions<PersonalLoanSort> = [
	{ label: "THM", value: "APR" },
	{ label: "Induló törlesztés", value: "START_INSTALLMENT" },
	{ label: "Teljes visszafizetés", value: "TOTAL_REDEMPTION" },
];

export const LOAN_AMOUNT_DATA_LIST = [
	800_000,
	1_000_000,
	2_000_000,
	3_000_000,
	5_000_000,
	10_000_000,
	generateList(1_250_000, MAX_LOAN_AMOUNT, 250_000),
]
	.flat()
	.map((item) => formatText(item, "ft").replace(" Ft", "")) as unknown as number[];

export const INCOME_DATA_LIST = [250_000, generateList(180_000, 1_500_000, 20_000)]
	.flat()
	.map((item) => formatText(item, "ft").replace(" Ft", "")) as unknown as number[];

export const EMPLOYMENT_MONTHS_DATA_LIST = [generateList(0, 11, 1), generateList(12, 36, 3)].flat();

export const BASIC_SEARCH_FIELDS = ["loanAmount", "maturityYears", "income"];
